"use strict";
exports.__esModule = true;
exports.toTransactionCommonRaw = exports.fromTransactionCommonRaw = void 0;
var bignumber_js_1 = require("bignumber.js");
var fromTransactionCommonRaw = function (raw) {
    var common = {
        amount: new bignumber_js_1.BigNumber(raw.amount),
        recipient: raw.recipient
    };
    if ("useAllAmount" in raw) {
        common.useAllAmount = raw.useAllAmount;
    }
    if ("subAccountId" in raw) {
        common.subAccountId = raw.subAccountId;
    }
    return common;
};
exports.fromTransactionCommonRaw = fromTransactionCommonRaw;
var toTransactionCommonRaw = function (raw) {
    var common = {
        amount: raw.amount.toString(),
        recipient: raw.recipient
    };
    if ("useAllAmount" in raw) {
        common.useAllAmount = raw.useAllAmount;
    }
    if ("subAccountId" in raw) {
        common.subAccountId = raw.subAccountId;
    }
    return common;
};
exports.toTransactionCommonRaw = toTransactionCommonRaw;
//# sourceMappingURL=common.js.map